import 'floating-vue/style.css'
import '@/assets/css/floatingvue-themes.css'

import type {Directive, DirectiveBinding} from 'vue'
import {vTooltip} from 'floating-vue'
import type {FloatingVueConfig} from 'node_modules/floating-vue/dist/config'

export const floatingVueOptions: {themes: Record<string, FloatingVueConfig>} = {
  themes: {
    Rateboard: {
      $extend: 'tooltip',
      popperTriggers: ['hover', 'focus', 'touch', 'click'],
    },
    'Rateboard-new-ui': {
      $extend: 'tooltip',
      popperTriggers: ['hover', 'focus', 'touch', 'click'],
    },
    'dropdown-select': {
      $extend: 'menu',
      delay: {
        show: 200,
        hide: 0,
      },
      distance: 0,
      autoSize: true,
    },
    'filter-preset': {
      $extend: 'menu',
      delay: {
        show: 200,
        hide: 100,
      },
      distance: 0,
      autoSize: true,
    },
    'widget-settings': {
      $extend: 'menu',
      delay: {
        show: 200,
        hide: 0,
      },
      autoHide: (event: Event) => !(event.target instanceof Element && event.target.closest('.v-popper--theme-dropdown-select')),
      popperTriggers: [], // prevent hover on popper from triggering hide (nested dropdowns render outside this popper)
      distance: 8,
      placement: 'bottom-end',
    },
    'new-ui-menu': {
      $extend: 'menu',
      delay: {
        show: 200,
        hide: 0,
      },
      hideTriggers: ['hover', 'touch'],
      showTriggers: ['click', 'touch', 'focus'],
      distance: 0,
    },
  },
}

function withUiVersionTheme(binding: DirectiveBinding) {
  const isNewUiEnabled = document.body.dataset.uiVersion !== 'legacy'
  const options = typeof binding.value === 'object' && binding.value !== null ? binding.value : {content: binding.value}
  return {...binding, value: {...options, theme: isNewUiEnabled ? 'Rateboard-new-ui' : 'Rateboard'}}
}

export const floatingVueTooltipDirectives: Directive = {
  beforeMount(el, binding) {
    vTooltip.beforeMount(el, withUiVersionTheme(binding))
  },

  updated(el, binding) {
    vTooltip.updated(el, withUiVersionTheme(binding))
  },

  beforeUnmount(el) {
    vTooltip.beforeUnmount(el)
  },
}
